import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import { api } from "../../evergis/api";
import { ResourceService } from "../../interfaces/service";
import { PUBLIC_ROLE, PUBLIC_ROLE_PERMISSION } from "../../hooks/acl/publicAccess";
import { promiseAllSettled } from "../../utils/promiseAllSettled";
import { invalidateResources } from "../../resources/invalidations";

const resolveAclUpdate =
  (resource: ResourceService) =>
  ({ name, makePublic }) =>
    makePublic
      ? resource.addPermissions(name, { data: [PUBLIC_ROLE_PERMISSION] })
      : resource.removePermissions(name, PUBLIC_ROLE);

function* updateAcl({ payload: { layers, tables } }: ReturnType<typeof actions.updateAcl>) {
  try {
    yield put(actions.setLoading(true));

    const layersAclPromises = layers.map(resolveAclUpdate(api.layers));
    const tableAclPromises = tables.map(resolveAclUpdate(api.tables));

    try {
      yield call(promiseAllSettled, [...layersAclPromises, ...tableAclPromises]);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }

    const layerNames = layers.map(({ name }) => name);
    const tableNames = tables.map(({ name }) => name);

    yield put(
      actions.setAcl({
        layers: layerNames,
        tables: tableNames,
      }),
    );

    invalidateResources([], layerNames, tableNames);
  } catch (error) {
    yield put(actions.setError(error));
  }
}

function* aclSaga() {
  yield takeLatest(actions.updateAcl, updateAcl);
}

export default aclSaga;
